import { render, staticRenderFns } from "./FaqsCategoryCreate.vue?vue&type=template&id=2e27aea2&lang=pug"
import script from "./FaqsCategoryCreate.vue?vue&type=script&lang=js"
export * from "./FaqsCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports